import { observer } from "mobx-react";
import { PageContainer } from "../../components/page";
import BreadCrumbs from "../../components/breadcrumsb";
import { PEProgressBar } from "../../components/linear-progress";

type Props = {
  hideBreadcrumbs?: boolean;
  loading: any;
  error: any;
  data: any;
};

const NotificationHistory = ({ loading, error, data }: Props) => {
  return (
    <div>
      {loading && <PEProgressBar />}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && data.length === 0 && (
        <p className="text-red-500">No notifications history found</p>
      )}
      {data.length > 0 &&
        data.map((notification: any) => (
          <Card key={notification.id} notification={notification} />
        ))}
    </div>
  );
};

export default observer(NotificationHistory);

const Card = ({
  notification,
}: {
  notification: {
    historyId: number;
    userID: null;
    venueID: number;
    notificationInAppSentCount: number;
    notificationSentCount: number;
    messageType: string;
    scheduleType: string;
    criteria: string;
    title: string;
    message: string;
    timeCreatedAt: number;
  };
}) => {
  return (
    <div className="mt-2 max-w-xl p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
      <div className="flex justify-between items-center mb-3 text-sm">
        <div>
          <FMessageType messageType={notification?.messageType} />
          <FSentTo to={notification?.criteria} />
        </div>
        <div>
          <FNotificationCount count={notification?.notificationSentCount} />
          <FAppCount count={notification?.notificationInAppSentCount} />
        </div>
      </div>
      <FTitle title={notification?.title} />
      <FMessage message={notification?.message} />
      <FDatetime date={notification?.timeCreatedAt} />
    </div>
  );
};

const FMessageType = ({ messageType }: { messageType: string }) => {
  console.log(messageType);

  if (messageType === "SingleUser") {
    return (
      <p className="font-bold text-yellow-500 flex gap-1">
        Sent to single user{" "}
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
            />
          </svg>
        </span>
      </p>
    );
  }

  if (messageType === "AllVenue") {
    return (
      <p className="font-bold text-yellow-500 flex gap-1">
        Sent to all venue{" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
          />
        </svg>
      </p>
    );
  }

  if (messageType === "CustomFilter") {
    return (
      <p className="font-bold text-yellow-500 flex gap-1">
        Sent to custom filter{" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.07v1.5a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L12 21l-1.256-.678a2.25 2.25 0 0 1-1.244-2.013V15.59a2.25 2.25 0 0 0-.659-1.591L3.41 8.57A2.25 2.25 0 0 1 2.75 6.98v-1.5c0-.514.384-.98.917-1.07A24.75 24.75 0 0 1 12 3Z"
          />
        </svg>
      </p>
    );
  }

  if (messageType === "CsvUpload") {
    return (
      <p className="font-bold text-yellow-500 flex gap-1">
        Sent via CSV upload{" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          />
        </svg>
      </p>
    );
  }

  // Return null or an empty fragment if no match (no "N/A")
  return <></>;
};
const FSentTo = ({ to }: { to: string }) => {
  return <p className="font-normal text-gray-700">Sent to {to}</p>;
};

const FTitle = ({ title }: { title: string }) => {
  return (
    <h5 className="mb-2 text-xl font-bold tracking-tight text-gray-900 dark:text-white">
      Title: {title}
    </h5>
  );
};

const FMessage = ({ message }: { message: string }) => {
  return <p className="mb-3 font-normal text-gray-700">Message: {message}</p>;
};

const FNotificationCount = ({ count }: { count: number }) => {
  return (
    <p className="text-sm text-gray-400">Sent notification count: {count}</p>
  );
};

const FAppCount = ({ count }: { count: number }) => {
  return <p className="text-sm text-gray-400">Sent in app count: {count}</p>;
};

const FDatetime = ({ date }: { date: number }) => {
  return (
    <p className="text-sm text-gray-400">
      Sent at: {new Date(date).toLocaleString()}
    </p>
  );
};
